import React from "react";
import AboutUs from "../components/AboutUs.jsx";
import OurApproach from "../components/OurApproach.jsx";
import PolicyProcessSteps from "../components/PolicyProcessSteps.jsx";
import ChatbotAi from "../components/ChatbotAi.jsx"

const About = () => {
  return (
    <div>
      <AboutUs />
      <OurApproach />
      <PolicyProcessSteps />
      <ChatbotAi />
    </div>
  );
};

export default About;